// The Turkish landing pages' ids and slugs (turkish.js has their words). Kept apart so i18n/routes.js,
// in every page's bundle, carries only these few lines.
export const TR_PAGE_IDS = ['yapay-zeka', 'tarih', 'korku', 'masal', 'bilgi', 'reklam'];

export const TR_SLUGS = {
  'yapay-zeka': 'yapay-zeka-ile-video-olusturma',
  tarih: 'tarih-videosu-yapma',
  korku: 'korku-hikayesi-videosu',
  masal: 'cocuk-masali-ve-fikra-videosu',
  bilgi: 'bilgi-videosu-yapma',
  reklam: 'isletme-reklam-videosu',
};
